import iconDistress from 'images/icon_service_distress.svg';
import iconPatrol from 'images/icon_service_patrol.svg';
import iconSitePatrol from 'images/icon_service_site_patrol.svg';
import iconTransportation from 'images/icon_service_transportation.svg';
import visitorManagement from 'images/icon_service_visitor_management.svg';
import crowdManagement from 'images/icon_service_crowd_management.svg';
import cleaning from 'images/icon_service_cleaning.svg';
import maintenance from 'images/icon_service_maintenance.svg';
import security from 'images/icon_security_task.svg';

export const serviceTypes = {
  emergency: {
    standard: 'EMERGENCY_STANDARD',
    armed: 'EMERGENCY_ARMED',
  },
  transport: {
    standard: 'TRANSPORT_STANDARD',
    secure: 'TRANSPORT_SECURE',
    protection: 'TRANSPORT_PROTECTION',
    armed: 'TRANSPORT_ARMED',
  },
  patrol: {
    singleSite: 'PATROL_SINGLE_SITE',
    multiSite: 'PATROL_MULTISITE',
    canine: 'PATROL_CANINE',
    armed: 'PATROL_ARMED',
  },
  visitorManagement: 'VISITOR_MANAGEMENT',
  crowdManagement: 'CROWD_MANAGEMENT',
  patrolCheckPointTask: 'PATROL_CHECKPOINT_TASK',
  cleaning: 'CLEANING',
  maintenance: 'MAINTENANCE',
  security: 'SECURITY',
};

export const SERVICE_ICON = {
  [serviceTypes.patrol.singleSite]: iconSitePatrol,
  [serviceTypes.patrol.multiSite]: iconPatrol,

  [serviceTypes.emergency.standard]: iconDistress,
  [serviceTypes.transport.standard]: iconTransportation,
  [serviceTypes.transport.secure]: iconTransportation,
  [serviceTypes.transport.protection]: iconTransportation,
  [serviceTypes.visitorManagement]: visitorManagement,
  [serviceTypes.crowdManagement]: crowdManagement,
  [serviceTypes.cleaning]: cleaning,
  [serviceTypes.maintenance]: maintenance,
  [serviceTypes.security]: security,
};

export const transportRegex = /TRANSPORT/g;
export const emergencyRegex = /EMERGENCY/g;
